import * as ajax from '../ajaxutil';
import * as domutils from '../domutils/index';

import EasyInputDate from '../domutils/easy-input-date';

const bootstrap = require('bootstrap');

class NyukinKeshikomiDialog {

    modalElement: HTMLElement;
    modal: any;

    seikyushoId: number|undefined;
    reloadTarget: HTMLElement|undefined;

    constructor() {
        this.modalElement = domutils.requireObject(document.querySelector<HTMLElement>("#nyukinKeshikomiDialog"));
        this.modal = bootstrap.Modal.getOrCreateInstance(this.modalElement);

        this.modalElement.addEventListener('hidden.bs.modal', event => {
            document.querySelectorAll<HTMLElement>("#summary").forEach((element) => {
                const reloadEvent = new CustomEvent("reload");
                element.dispatchEvent(reloadEvent);
            });

            document.querySelectorAll<HTMLElement>("#memory").forEach((element) => {
                const reloadEvent = new CustomEvent("reload");
                element.dispatchEvent(reloadEvent);
            });
        });

        this.modalElement.querySelectorAll<HTMLElement>("[data-action=reload-nyukin-keshikomi-dialog-body]").forEach((element) => this.handleReloadNyukinKeshikomiDialogBody(element));
    }

    private getSeikyushoId(): number {
        return domutils.requireObject(this.seikyushoId);
    }

    private getReloadTarget(): HTMLElement {
        return domutils.requireObject(this.reloadTarget);
    }

    show(seikyushoId: number, reloadTarget: HTMLElement) {
        this.seikyushoId = seikyushoId;
        this.reloadTarget = reloadTarget;

        this.reloadBody();
        this.modal.show();
    }

    private handleReloadNyukinKeshikomiDialogBody(element: HTMLElement) {

        let afterLoad = () => {
            this.modalElement.querySelectorAll<HTMLInputElement>("input[type=date]").forEach((element) => new EasyInputDate(element));
            this.modalElement.querySelectorAll<HTMLElement>("[data-action=send-create-seikyusho-nyukingaku]").forEach((element) => this.handleNew(element));
            this.modalElement.querySelectorAll<HTMLElement>("[data-action=send-update-seikyusho-nyukingaku]").forEach((element) => this.handleUpdate(element));
            this.modalElement.querySelectorAll<HTMLElement>("[data-action=send-delete-seikyusho-nyukingaku]").forEach((element) => this.handleDelete(element));
        }

        ajax.setReload(element, afterLoad);
    }

    private handleNew(element: HTMLElement) {
        element.addEventListener("click", (ev) => {
            let afterLoad = (response: any) => {
                this.reloadBody();
                this.reloadOriginRecord();
            }

            ajax.setSendForm(element, undefined, afterLoad)
        });
    }

    private handleUpdate(element: HTMLElement) {
        element.addEventListener("change", (ev) => {
            let afterLoad = (response: any) => {
                this.reloadOriginRecord();
            }

            ajax.setSendForm(element, undefined, afterLoad)
        });
    }

    private handleDelete(element: HTMLElement) {
        element.addEventListener("click", (ev) => {
            let afterLoad = (response: any) => {
                this.reloadBody();
                this.reloadOriginRecord();
            }

            ajax.setSendForm(element, undefined, afterLoad)
        });
    }

    private reloadBody() {
        const table = domutils.requireObject(this.modalElement.querySelector("[data-action=reload-nyukin-keshikomi-dialog-body]"));
        const reloadEvent = new CustomEvent("reload", { detail: { id: this.getSeikyushoId() } });
        table.dispatchEvent(reloadEvent);
    }

   private reloadOriginRecord() {
        const reloadEvent = new CustomEvent("reload");
        this.getReloadTarget().dispatchEvent(reloadEvent);
    }

}

export default NyukinKeshikomiDialog;